export const REVIEWER_LOGIN_TOKEN = '{{REVIEWER_LOGIN}}';
export const emptyReleaseContent = () => ({ version_name: '', release_notes: [], review_notes: '', locale_basis: '' });
export const contentPayload = row => ({ version_name: row.version_name, release_notes: row.release_notes, review_notes: row.review_notes, locale_basis: row.locale_basis });
const credentialPattern = /reviewer@|(?:otp(?:\s+code)?|verification\s+code|password)\s*[:=]\s*[0-9A-Za-z]/i;
export const utf8Bytes = value => new TextEncoder().encode(value).length;
export function validateReleaseContent(input, approving = false) {
  if (!/^\d+\.\d+\.\d+$/.test(input.version_name) || input.version_name.length > 50) return 'version';
  if (input.locale_basis.length > 2000 || utf8Bytes(input.review_notes) > 4000) return 'limit';
  if (credentialPattern.test(input.review_notes)) return 'privateAccess';
  if (input.release_notes.length > 100) return 'limit';
  const seen = new Set();
  for (const note of input.release_notes) {
    if (!['IOS', 'ANDROID'].includes(note.platform) || !/^[a-z]{2,3}(-[A-Za-z0-9]{2,8}){0,2}$/.test(note.locale)) return 'locale';
    const key = `${note.platform}:${note.locale}`;
    if (seen.has(key)) return 'duplicate';
    seen.add(key);
    if ([...note.text].length > (note.platform === 'ANDROID' ? 500 : 4000)) return 'limit';
    if (credentialPattern.test(note.text) || note.text.includes(REVIEWER_LOGIN_TOKEN)) return 'privateAccess';
    if (note.text && (note.text.split('\n').length > 2 || note.text.split('\n').some(line => !/^• \S/.test(line)))) return 'bullets';
    if (approving && !note.text.trim()) return 'incomplete';
  }
  if (approving && (!input.locale_basis.trim() || !['IOS', 'ANDROID'].every(p => input.release_notes.some(n => n.platform === p)) || input.review_notes.split(REVIEWER_LOGIN_TOKEN).length !== 2)) return 'incomplete';
  return null;
}
// Import version-content.json from the app repo without carrying build/runtime/credentials into the API.
export function importReleaseContent(raw) {
  if (!raw || typeof raw !== 'object' || !Array.isArray(raw.release_notes)) throw new Error('import');
  const notes = raw.release_notes.flatMap(note => note.platform ? [{ platform: note.platform, locale: note.locale, text: note.text }] : [
    { platform: 'IOS', locale: note.ios_locale, text: note.text },
    { platform: 'ANDROID', locale: note.android_locale, text: note.text },
  ]);
  const input = { version_name: raw.version_name || raw.version || '', release_notes: notes, review_notes: raw.review_notes ?? raw.ios_review_notes ?? '', locale_basis: raw.locale_basis || '' };
  if (typeof input.review_notes !== 'string' || typeof input.locale_basis !== 'string' || typeof input.version_name !== 'string' || notes.some(n => typeof n.text !== 'string' || typeof n.locale !== 'string')) throw new Error('import');
  const error = validateReleaseContent(input);
  if (error) throw new Error(error);
  return input;
}

// Play Console expects each locale tag on its own line, with public notes only.
export function formatGooglePlayReleaseNotes(notes) {
  const android = notes.filter(note => note.platform === 'ANDROID');
  if (!android.length || android.some(note => !note.text.trim())) throw new Error('googleIncomplete');
  const error = validateReleaseContent({ version_name: '1.0.0', release_notes: android, review_notes: '', locale_basis: '' });
  if (error) throw new Error(error);
  if (android.some(note => /<\/?[a-z]{2,3}(?:-[A-Za-z0-9]{2,8}){0,2}>/.test(note.text))) throw new Error('googleTags');
  return android.map(note => `<${note.locale}>\n${note.text}\n</${note.locale}>`).join('\n\n');
}
